(() => {
  const init = () => {
    const PRESS_SELECTOR = '[data-press-section]';

    document.querySelectorAll(PRESS_SELECTOR).forEach((section) => {
      const SWIPER_SELECTOR = '[data-swiper]';
      const NEXT_BUTTON_SELECTOR = '[data-next-swiper]';
      const PREV_BUTTON_SELECTOR = '[data-prev-swiper]';
      
      const swiperEl = section.querySelector(SWIPER_SELECTOR);
      const nextEl = section.querySelector(NEXT_BUTTON_SELECTOR);
      const prevEl = section.querySelector(PREV_BUTTON_SELECTOR);

      new Swiper(swiperEl, {
        loop: false,
        navigation: {
          addIcons: false,
          nextEl,
          prevEl,
        },
        pagination: false,
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 2 },
        },
      });
    });
  };
  
  if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            init();
        });
    } else {
        init();
    }
})();